import React from 'react'
import ReactDOM from 'react-dom'
import StaticChart from '../src/javascripts/static_chart'

const options = {
  chart: {
    type: 'line',
    height: '100%'
  },
  title: {
    text: 'Recoil By Bullet Weight and Velocity'
  },
  subtitle: {
     text: '10 pound Rifle & Typical Charge Weights Assumed'
  },
  xAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Muzzle Velocity (fps)'
    }
  },
  yAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Recoil Energy (ft-lb)'
    }
  },
  tooltip: {
    headerFormat: "{series.name} @ {point.key:.0f} fps<br>",
    pointFormat: "{point.y:.1f} ft-lb"
  },
  series: [
    {"name":"50 gr.","data": [[2000,0.8],[2100,0.9],[2200,1.0],[2300,1.1],[2400,1.3],[2500,1.4],[2600,1.6],[2700,1.8],[2800,1.9],[2900,2.2],[3000,2.4],[3100,2.6],[3200,2.9],[3300,3.1],[3400,3.4],[3500,3.7]]},
    {"name":"100 gr.","data":[[2000,2.5],[2100,2.8],[2200,3.2],[2300,3.6],[2400,4.0],[2500,4.5],[2600,5.0],[2700,5.5],[2800,6.1],[2900,6.7],[3000,7.3],[3100,8.0],[3200,8.8],[3300,9.5],[3400,10.4],[3500,11.3]]},
    {"name":"150 gr.","data":[[2000,5.3],[2100,6.0],[2200,6.8],[2300,7.6],[2400,8.5],[2500,9.5],[2600,10.5],[2700,11.6],[2800,12.8],[2900,14.1],[3000,15.4],[3100,16.9],[3200,18.4],[3300,20.0],[3400,21.8],[3500,23.6]]},
    {"name":"200 gr.","data":[[2000,9.6],[2100,10.8],[2200,12.2],[2300,13.7],[2400,15.3],[2500,17.1],[2600,18.9],[2700,20.9],[2800,23.1],[2900,25.4],[3000,27.8],[3100,30.4],[3200,33.2],[3300,36.1],[3400,39.2],[3500,42.5]]},
    {"name":"300 gr.","data":[[2000,15.8],[2100,18.0],[2200,20.3],[2300,22.8],[2400,25.6],[2500,28.5],[2600,31.7],[2700,35.1],[2800,38.8],[2900,42.7],[3000,46.9],[3100,51.3],[3200,56.1],[3300,61.1],[3400,66.5],[3500,72.2]]},
    {"name":"350gr.","data":[[2000,25.8],[2100,29.4],[2200,33.3],[2300,37.6],[2400,42.3],[2500,47.3],[2600,52.7],[2700,58.6],[2800,64.9],[2900,71.7],[3000,79.0],[3100,86.8],[3200,95.1],[3300,104.0],[3400,113.5],[3500,123.5]]}
  ]
};

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <StaticChart options={options} />,
    document.getElementById('recoil_chart')
  )
});
